import React, { useRef, useState, useEffect } from 'react';
import Picker from '@emoji-mart/react';
import data from '@emoji-mart/data';
import EmojiPicker from 'emoji-picker-react';
import cn from 'classnames';

import Header from './components/Header';
import Messages from './components/Messages';
import Sender from './components/Sender';
import QuickButtons from './components/QuickButtons';
import '../../../../../../styles.css';
import { useSelector } from 'react-redux';

const Conversation = ({
  title,
  subtitle,
  senderPlaceHolder,
  showCloseButton,
  disabledInput,
  autofocus,
  className,
  sendMessage,
  toggleChat,
  profileAvatar,
  profileClientAvatar,
  titleAvatar,
  config,
  onQuickButtonClicked,
  onTextInputChange,
  sendButtonAlt,
  showTimeStamp,
  resizable,
  emojis,
  showStartScreen,
  onSubmit
}) => {
  const { messages } = useSelector((state) => ({
    messages: state.messages.messages,
  }));
  const [containerDiv, setContainerDiv] = useState(null);
  let startX, startWidth;
  const [pickerOffset, setPickerOffset] = useState(0);
  const senderRef = useRef(null);
  const [pickerStatus, setPickerStatus] = useState(false);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerStatus && !event.target.closest('.emoji-style')) {
        // closePicker();
        setPickerStatus(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [pickerStatus]);

  const initResize = (e) => {
    if (resizable) {
      startX = e.clientX;
      if (document.defaultView && containerDiv) {
        startWidth = parseInt(document.defaultView.getComputedStyle(containerDiv).width);
        window.addEventListener('mousemove', resize, false);
        window.addEventListener('mouseup', stopResize, false);
      }
    }
  };

  const resize = (e) => {
    if (containerDiv) {
      containerDiv.style.width = startWidth - e.clientX + startX + 'px';
    }
  };

  const stopResize = (e) => {
    window.removeEventListener('mousemove', resize, false);
    window.removeEventListener('mouseup', stopResize, false);
  };

  const onSelectEmoji = (emoji) => {
    senderRef.current.onSelectEmoji(emoji);
    setPickerStatus(true);
  };

  const togglePicker = () => {
    setPickerStatus((prevPickerStatus) => !prevPickerStatus);
  };

  const handleSendMessage = (event) => {
    sendMessage(event);
    if (pickerStatus) setPickerStatus(false);
  };

  const handleSubmit = () => {
    onSubmit();
  };

  return (
    <div
      id="rcw-conversation-container"
      onMouseDown={initResize}
      className={cn('rcw-conversation-container', className)}
      aria-live="polite">
      {resizable && <div className="rcw-conversation-resizer" />}
      <Header
        title={title}
        subtitle={subtitle}
        toggleChat={toggleChat}
        showCloseButton={showCloseButton}
        titleAvatar={titleAvatar}
        messages={messages}
        onSendMessage={handleSendMessage}
        showStartScreen={showStartScreen}
      />
      <Messages
        profileAvatar={profileAvatar}
        profileClientAvatar={profileClientAvatar}
        showTimeStamp={showTimeStamp}
      />

      {showStartScreen ?
        <div style={{ marginBottom: "25px", marginTop: '25px' }}>
          <button className="rate-submit-button" onClick={handleSubmit} style={{ background: '#000', color: '#fff' }}>
            Start new chat
          </button>
        </div>
        :
        <>
          <QuickButtons onQuickButtonClicked={onQuickButtonClicked} />
          {emojis && pickerStatus && (
            <EmojiPicker
              onEmojiClick={onSelectEmoji}
              open={pickerStatus}
              skinTonesDisabled={false}
              previewConfig={{ showPreview: false }}
              height={2000}
              width={380}
              className="emoji-style"
            />
          )}
          <Sender
            ref={senderRef}
            sendMessage={handleSendMessage}
            placeholder={senderPlaceHolder}
            disabledInput={disabledInput}
            autofocus={autofocus}
            onTextInputChange={onTextInputChange}
            buttonAlt={sendButtonAlt}
            config={config}
            onPressEmoji={togglePicker}
            onChangeSize={setPickerOffset}
          /></>}
    </div>
  );
};

export default Conversation;
